export default __webpack_public_path__ + "static/media/main_logo.a77e7e4a.png";